// jQuery(document).ready(function() {
//     add_quotation();
// });

var quotation_entity_ajax = {};
function add_quotation(vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/quotation/add',
        onOpen: function (elm, popup) {
            load_quotation_selectors(elm, vars);

            elm.find('form').ajaxFormSubmit(function(data, last_form){
                elm.doneLoading();
                if(last_form.hasClass('header-fields')) {
                    elm.find('form.choose-products').find('table').reloadThisElement();
                    elm.find('.address-options-wrapper').html(data);
                } else if(last_form.hasClass('add-notes')) {
                    load_paperwork_preview(elm, last_form, 'quotation');
                } else if(last_form.hasClass('submit')) {
                    $('body').isLoading();
                    reload_location_if_needed();
                    if (!document.closeWindow) open_new_object(view_quotation, data);
                }
                ajax_popup_scroll_to_next_screen(function() {
                    var a = elm.find('.scroll-screen.active');
                    var next_form = a.find('form');
                    next_form.find('input.generated-input').remove();
                    last_form.find(':input').each(function() {
                        var name = $(this).attr('name');
                        var type = $(this).attr('type');
                        if(name != undefined && type != 'submit' && name != "_token" && (type != "checkbox" || $(this).is(':checked'))) {
                            const v = $(this).val();
                            if ($(this).prop('tagName') === 'TEXTAREA') {
                                next_form.append('<textarea style="display: none;" name="' + $(this).attr('name') + '" class="generated-input">' + v + '</textarea>');
                            } else {
                                next_form.append('<input type="hidden" name="'+$(this).attr('name')+'" value="' + v + '" class="generated-input" />');
                            }
                        }
                    });
                }.bind([elm, last_form]));
            }.bind([elm,popup]), function(xhr, status, error) {
                elm.doneLoading();
                console.log([status,error]);
                ajax_popup_set_scroll_screen_progress(elm);
            }.bind([elm,popup]), function() {
                elm.isLoading();
            });
        }
    });
    return false;
}
function delete_quotation(id, identifier, close = false) {
    return delete_paperwork_object('quotation', id, identifier, close);
}
function view_quotation(id, callback) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/quotation/view/'+id,
        onOpen: function(elm, popup) {
            load_quotation_selectors(elm, { existing: true });

            elm.find('form').ajaxFormSubmit(function(data){
                updateObject('quotation', id);

                $('body').doneLoading();
                squde_reload_for_flashes();

                if(callback) {
                    callback(data, elm, popup);
                }
                if (document.closeWindow) popup.close();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function load_quotation_selectors(elm, vars) {
    load_contact_and_company_selectors(elm, vars);

    quotation_load_product_selector(elm);
}
function quotation_load_product_selector(elm, client_id) {
    paperwork_load_product_selector(elm,quotation_entity_ajax, client_id);
}
function quotation_add_products(id, client_id) {
    paperwork_add_products('quotation', id, client_id);
    return false;
}
function remove_product_from_quotation(id, new_quotation) {
    var $ = jQuery.noConflict();

    if(new_quotation == undefined) {
        new_quotation = 0;
    }
    var after_confirm = function() {
        $.post('/administration/quotation/remove_product',{id:id, new_quotation:new_quotation}, function() {
            $('.quotation-products-table').reloadThisElement();
            if(new_quotation == 0) {
                squde_flash("Artikel van offerte verwijderd");
                reload_location_if_needed(false);
            }
        });
    }

    if(id != "new") {
        confirm("Weet u zeker dat u dit artikel van de offerte wilt verwijderen?", function() {
            after_confirm();
        });
    } else {
        after_confirm();
    }
}
function view_quotation_product(id, new_quotation, client_id) {
    view_paperwork_product('quotation', id, new_quotation, client_id);
    return false;
}
function migrate_quotation_to_order(id) {
    jQuery.post('/administration/quotation/makeOrderFromQuotation/' + id, function(order) {
        reload_location_if_needed();
        redirect_and_do('/administration/orders', function() {
            view_order(order.id);
        });
    });
    return false;
}

function migrate_quotation_to_invoice(id) {
    jQuery.post('/administration/quotation/makeInvoiceFromQuotation/' + id, function(invoice) {
        reload_location_if_needed();
        redirect_and_do('/administration/invoices', function() {
            view_invoice(invoice.id);
        });
    });
    return false;
}
